import { useState } from 'react'

import { useRisksOf, useViolationsOf } from '../../demo/selectors'
import { AlertBar, Button, GlossaryText } from '../../ui'
import { riskSummary, riskTitle, violationLabel } from '../monitor/compliance'
import { RiskDialog } from './RiskDialog'
import { ViolationDialog } from './ViolationDialog'

export function ComplianceAlerts({ campaignId }: { campaignId: string }) {
  const violations = useViolationsOf(campaignId)
  const risks = useRisksOf(campaignId)
  const [violationOpen, setViolationOpen] = useState(false)
  const [riskOpen, setRiskOpen] = useState(false)

  return (
    <>
      <div data-scope="detail-compliance-alerts">
        {violations.length > 0 ? (
          <AlertBar tone="red" action={<Button onClick={() => setViolationOpen(true)}>去处理</Button>}>
            <b><GlossaryText text={violationLabel(violations.length)} /></b>，这部分预算已停止消耗
          </AlertBar>
        ) : null}
        {risks.length > 0 ? (
          <AlertBar tone="orange" action={<Button variant="secondary" onClick={() => setRiskOpen(true)}>查看建议</Button>}>
            <b>{riskTitle(risks.length)}</b>：<GlossaryText text={riskSummary(risks)} />
          </AlertBar>
        ) : null}
      </div>
      <ViolationDialog open={violationOpen} campaignId={campaignId} onClose={() => setViolationOpen(false)} />
      <RiskDialog open={riskOpen} campaignId={campaignId} onClose={() => setRiskOpen(false)} />
    </>
  )
}
